/* eslint-disable */
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { Empty } from 'ant-design-vue';
import { tagList } from '@/api/tags';
import { downloadFile } from 'assets/js/download';
import infiniteScroll from 'vue-infinite-scroll';
import feishuGroup from './feishuGroup/index';
import { getComment, getCompanyNotes, addCompanyNotes, competitor, financing } from '@/api/work';
import { searchByName, downloadFile as downloadFileApi, roundList } from '@/api/common';
import {
  getDetail,
  recentUpload,
  getCompanyFile,
  getFileList,
  editFileName,
  deleteFile,
  getPermissionUsers,
  setPermissionUsers,
  getMeeting,
  getVoteList,
  cancelMeeting,
  getNoSummaryList,
  historyStage,
  audioMeetingDetail,
  audioPermission,
  checkFeishuLinkPermission,
  getFinanceQuarterNewest
} from '@/api/project';
import { companyFileRoundInfo, roundChange } from '@/api/document';
import { queryMeetingStatus } from '@/api/meeting';
import tag from '@/components/base/tag';
import tinymce from '@/components/base/tinymce';
import dataItem from '@/components/home/dataItem';
import fileIcon from '@/components/base/fileIcon';
import projectTag from 'components/project/projectTag';
import documentUpload from '@/components/project/documentUpload';
import projectInfo from '@/components/project/projectInfo';
import projectKp from '@/components/project/projectKp';
import finance from '@/components/project/finance';
import selectMember from '@/components/project/selectMember';
import askMeeting from '@/components/project/askMeeting';
import askVote from '@/components/project/askVote';
import roundLine from '@/components/project/roundList';
import voteListDrawer from '@/components/project/voteListDrawer';
import authApply from '@/components/project/authApply';
import portfolio from './portfolio';
import { fileSuffix } from '@/const/common.js';
import { MEETING_AUDIO_FILETYPE_ID, SETTLEMENT_INVESRMENT_FILETYPE_ID, SETTLEMENT_EXIT_FILETYPE_ID } from '@/common/constant';
import Event from '@/utils/event';
import keyNode from '@/components/project/keyNode';
import selectItem from '@/components/base/stageSelect';
import { getPermissions } from '@/utils/utils';
import { of } from 'core-js/fn/array';
import stageMulSelect from '@/components/base/stageMulSelect.vue';
import { hasPermission } from '@/utils/utils';
import document from './document/index';
import TraceButton from './traceButton';

const phaseMap = {
  0: '发展期',
  1: '融资期'
};

export default {
  directives: { infiniteScroll },
  filters: {
    retainYMD(value) {
      return moment(value).format('YYYY-MM-DD');
    }
  },
  components: {
    TraceButton,
    document,
    tag,
    fileIcon,
    projectTag,
    tinymce,
    dataItem,
    documentUpload,
    projectInfo,
    selectMember,
    askMeeting,
    askVote,
    keyNode,
    selectItem,
    stageMulSelect,
    roundLine,
    voteListDrawer,
    projectKp,
    finance,
    portfolio,
    feishuGroup,
    authApply
  },
  data() {
    const columns = [
      { title: '文件名', scopedSlots: { customRender: 'name' }, width: 250 },
      {
        title: '上传人',
        customRender: (text, record) => {
          if (record.creator) {
            return record.creator.nickname;
          }
          return '';
        },
        align: 'center',
        width: 50
      },
      {
        title: '文件大小',
        dataIndex: 'sizeDesc',
        align: 'center',
        scopedSlots: { customRender: 'sizeDesc' },
        width: 70
      },
      {
        title: '上传时间',
        dataIndex: 'createAt',
        align: 'center',
        scopedSlots: { customRender: 'time' },
        width: 100
      },
      {
        title: '所属轮次',
        align: 'center',
        customRender: value => {
          let phaseAndRoundList = value.phaseAndRoundMaps;
          let render = '';
          phaseAndRoundList.forEach(_ => {
            render += this.roundListMap[_.round] + '轮' + phaseMap[_.phase] + ' ';
          });
          return render;
        },
        width: 200
      },
      {
        title: '操作',
        align: 'center',
        scopedSlots: { customRender: 'action' },
        width: 170
      }
    ];
    const financeColumns = [
      { title: '轮次', dataIndex: 'round' },
      { title: '融资时间', dataIndex: 'time' },
      { title: '融资金额', dataIndex: 'finacingValue' },
      { title: '投资方', dataIndex: 'investors' },
      { title: '比例', dataIndex: 'ratio' },
      { title: '估值', dataIndex: 'appraisement' },
      { title: 'FA', dataIndex: 'createAt' },
      {
        title: '来源',
        align: 'center',
        scopedSlots: { customRender: 'source' }
      }
    ];
    const competitorColumns = [
      { title: '公司名称', scopedSlots: { customRender: 'company' } },
      { title: '简介', dataIndex: 'brief' },
      { title: '行业领域', dataIndex: 'industry' },
      { title: '地区', dataIndex: 'region' },
      { title: '融资时间', dataIndex: 'firstFinacingTime' },
      { title: '当前轮次', dataIndex: 'curRound' },
      { title: '融资金额', dataIndex: 'finacingValue' },
      { title: '投资方', dataIndex: 'investors' }
    ];
    return {
      moment,
      currentUser: this.$store.state.user.userInfo,
      attachments: [],
      projectId: this.$route.query.id,
      project: {},
      showEdit: false,
      documentModal: false,
      annexModal: false,
      permissionModal: false,
      askMeetingModal: false,
      askVoteModal: false,
      fileList: [],
      meetingAudioList: [],
      editorConfig: {
        uploadImgServer: '',
        menus: [
          'bold', // 粗体
          'italic', // 斜体
          'image', // 图片
          'link', // 链接
          '|',
          'fullscreen' // 全屏
          // 'head',	// 标题
          // 'fontSize',  // 字号
          // 'underline',  // 下划线
          // 'strikeThrough',  // 删除线
          // 'foreColor',  // 文字颜色
          // 'justify',	// 居中
          // 'list',	// 无序列表
          // 'quote',	// 引用
          // 'table',	// 表格
        ]
      },
      columns,
      competitorColumns,
      financeColumns,
      financeLoading: false,
      competitorLoading: false,
      financeList: [],
      competitorList: [],
      financePage: 10,
      competitorPage: 10,
      financeNo: 1,
      competitorNo: 1,
      financeTotal: 1,
      competitorTotal: 1,
      loading: false,
      showModel: '',
      currentRow: {},
      pageSize: 10,
      current: 1,
      totalNum: 100,
      fileTypeId: [],
      annexId: [],
      fileName: '',
      documentList: [],
      searchType: '1',
      editModal: false,
      // editRound: false,
      new_filename: '',
      currentKey: this.$route.query.tab || '1',
      fileType: [],
      permission: [], //默认权限
      customPermission: [], //自定义权限
      permissionLoad: false,
      tempEdit: '',
      companyFileId: [],
      meetPage: 1,
      meetingList: [],
      voteList: [],
      editMeetingId: null,
      meetloading: false,
      voteloading: false,
      meetTotal: '',
      busy: false,
      companyNotes: [],
      tagsList: [],
      tags: [],
      page: 1,
      pageNum: 25,
      searchUserId: '',
      load_more: true,
      notifyUserIds: [],
      ownerUserIds: [],
      notesTagIds: [],
      projectTagIds: [],
      projectMemberList: [],
      visibleTaskTagMenu: false,
      visibleProjectTagMenu: false,
      savenoteLoading: false,
      execDate: null, //moment(new Date(), 'YYYY-MM-DD'),
      backUserIds: [],
      backUserIds2: [],
      authType: '0', //0默认 ，1自定义
      meetingStatusArr: [], //1申请上会，0撤销上会，2不可点击（申请上会管理员创建会议了） 0=未申请上会 1=已申请上会 2=已排会
      noticeModal: false, //控制提示框的显示隐藏(通知飞书)
      currentMeeting: [], //智能提示选中value
      noSummaryList: [],
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      isShowNotice: false, //智能提示的显示隐藏
      defalutText: '',
      infoIndex: 0,
      projectBase: {},
      projectStage: {},
      phaseMap: phaseMap,
      historyStage: [],
      isSelectedAll: true,
      roundList: [],
      phase: '',
      round: '',
      selectedPhase: '',
      selectedRound: '',
      roundValue: {},
      historyStageMap: {},
      // fileId: ''
      showAskVote: false,
      roundNameShow: '',
      roundListMap: {},
      selected: {},
      notesLoading: false,
      roundChangeModal: false,
      fileRoundInfo: {},
      fileRoundAndPhase: [],
      roundMap: {},
      reFresh: true,
      fileRoundEditPermission: false,
      selectRoundNow: -1,
      projectRoundEditPermission: false,
      voteVisible: false,
      tabMap: {
        1: '项目-工作进展',
        2: '项目-项目信息',
        3: '项目-项目文档',
        4: '项目-第三方信息',
        5: '项目-团队成员整体'
      },
      askMeetingType: 1, // 1-申请上会 2-ceo 3-修改 0-followon
      stageObj: {},
      applyAuthShow: false,
      authApplyPermission: false,
      pageLoading: true,
      permissionMap: {},
      type: 1,
      financeQuarterNewest: ''
    };
  },
  watch: {
    pageSize(val) {
      this.getCompanyFile();
    },
    current(val) {
      this.getCompanyFile();
    },
    fileName() {
      this.$ga.gaUploadCustomEvent('项目-文档-搜索文件名');
      this.search();
    }
  },
  computed: {
    scrollOps() {
      return {
        rail: {
          background: '#e5e5e5',
          opacity: 1
        },
        bar: {
          keepShow: true
        }
      };
    },
    isTeam() {
      let { project } = this;
      let currentUser = this.$store.state.user.userInfo;
      let isDealLeader = ((project.member || {}).dls || []).some(_ => _.id === currentUser.id);
      let isDealMember = ((project.member || {}).dms || []).some(_ => _.id === currentUser.id);
      return isDealLeader || isDealMember;
    },
    showMeetingEdit() {
      let tmp = this.meetingStatusArr.find(_ => {
        return _.meetingType === 1;
      });
      return tmp && tmp.status === 1 && (this.permissionMap['createMeeting'] || this.isTeam);
    },
    ...mapGetters(['userInfo', 'token'])
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  async created() {
    const { permissions: queue } = this.userInfo || {};
    this.authApplyPermission = hasPermission(queue, '/project/authApply');
    this.getDetail('init');
    this.getRoundList();
    // this.getHistoryStage();
    this.getList();
    if (this.$route.query.time) {
      this.createLabel(null, this.$route.query.time, this.$route.query.meetingId);
    }
    if (this.$route.query.vote) {
      this.voteVisible = true;
    }
    if (this.$route.query.noPermission) {
      this.applyAuthShow = true;
    }
    this.getFinanceQuarterNewest();
  },

  mounted() {
    Event.$on('toInfoDetail', index => {
      this.infoIndex = index;
    });
  },

  methods: {
    toRound() {
      this.$router.push({ name: 'round', query: { projectId: this.projectId } });
    },
    //智能提示取消
    cancelCreateLabel() {
      this.isShowNotice = false;
      this.showEdit = true;
      this.defalutText = '';
    },
    getRoundList() {
      roundList().then(res => {
        if (res.code === 200) {
          this.roundList = res.data;
          this.roundList.forEach(e => {
            this.roundListMap[e.id] = e.name;
          });
        }
      });
    },
    //智能提示创建
    createLabel(event, time, meetingId) {
      this.isShowNotice = false;
      let currentDate = this.currentMeeting.meetingDate;
      let formatDate;
      if (currentDate) {
        formatDate = currentDate.substring(0, 4) + '-' + currentDate.substring(4, 6) + '-' + currentDate.substring(6, 8);
      }
      if (time) {
        formatDate = moment.unix(this.$route.query.time).format('YYYY-MM-DD');
        this.currentMeeting.meetingId = meetingId;
      }
      this.backUserIds = [this.currentUser];
      this.execDate = moment(formatDate, 'YYYY-MM-DD');
      this.showEdit = true;
      this.defalutText = '上会讨论纪要';
      this.notesTagIds = [
        {
          entityId: null,
          id: 67,
          name: '上会讨论记录',
          sort: 6,
          status: 'NORMAL',
          type: 'NOTES'
        }
      ];
    },
    //提示框取消
    cancelUpload() {
      this.annexModal = false;
      this.documentModal = false;
      this.noticeModal = false;
    },
    //上传最近文档（上传材料）
    loadMaterials() {
      // if (this.meetingStatus === 2) {
      //   this.noticeModal = true;
      // }
      this.documentModal = true;
    },
    //点击附件回调
    loadAnnex() {
      let index = this.meetingStatusArr.findIndex(_ => {
        return _.meetingType === 1;
      });
      let status = this.meetingStatusArr[index].status;
      if (status === 2) {
        this.noticeModal = true;
      }
      this.annexModal = true;
    },
    //自定义事件附件上传
    uploadedFile(files) {
      this.attachments.push(...files);
    },
    async getMeeting() {
      this.meetPage = 1;
      this.meetloading = true;
      const res = await getMeeting({
        page: 1,
        pageSize: 10,
        searchName: '',
        companyId: this.$route.query.id,
        phase: this.phase,
        roundId: this.round
      });
      this.meetloading = false;
      if (res.code == 200) {
        // this.meetingStatus = res.data.status;
        this.meetTotal = res.data.pageVo.total;
        this.meetingList = res.data.pageVo.list || [];
      } else {
        this.meetingList = [];
      }
    },
    clickMeeting() {
      this.$router.push({ path: '/project/meetingList', query: { companyId: this.projectId } });
    },
    askMeeting(val) {
      this.askMeetingType = val;
      this.askMeetingModal = true;
      this.editMeetingId = null;
    },
    saveMeeting() {
      this.askMeetingModal = false;
      this.getDetail();
      this.getList();
      this.meetingStatusArr = [];
      // this.getMeetingStatus();
      this.$refs.keyNode.fetchNodes();
      // location.reload();
      // this.getMeeting();
    },
    editMeeting() {
      this.askMeetingType = 3;
      this.askMeetingModal = true;
    },
    willCancelMeeting() {
      this.$confirm({
        title: `确定撤回吗?`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.cancelMeeting();
        }
      });
    },
    cancelMeeting() {
      cancelMeeting({
        companyId: this.projectId
      }).then(res => {
        this.meetingStatus = 1;
        this.getDetail();
        this.$refs.keyNode.fetchNodes();
      });
    },
    getVoteList() {
      this.voteloading = true;
      getVoteList({
        // page: 1,
        // pageSize: 10,
        // searchName: '',
        companyId: this.$route.query.id
        // phase: this.phase,
        // roundId: this.round
      }).then(res => {
        if (res.code === 200) {
          this.voteloading = false;
          this.voteList = res.data;
        }
      });
    },
    askVote() {
      this.askVoteModal = true;
    },
    clickVote(item) {
      this.voteVisible = true;
    },
    clickAllDoc() {
      this.callback('3');
    },
    clickMeetingAudio(item) {
      this.gotoAudio({ ...item, source: item.audio ? item.audio.source : undefined }, 1);
    },
    gotoMeetingDetail(meeting) {
      let url = this.$router.resolve({ path: '/meeting/detail', query: { companyId: this.projectId, meetingProjectId: meeting.meetingProjectId } });
      window.open(url.href, '_blank');
    },
    async gotoAudio(item, type) {
      // 调一下接口看有没有权限 / 是飞书妙记还是天池录音
      try {
        let res = await audioPermission({ meetingProjectId: item.meetingProjectId, meetingType: type });
        if (res.code === 200) {
          let url = '';
          if (item.source === 1) {
            // 飞书妙记
            let res2 = await audioMeetingDetail({ meetingProjectId: item.meetingProjectId, meetingType: type });
            url = res2.data.audioIdPath;
          } else {
            // 天池录音
            let routeUrl = this.$router.resolve({
              path: '/project/meetingAudio',
              query: { meetingProjectId: item.meetingProjectId, meetingType: type }
            });
            url = routeUrl.href;
          }
          window.open(url, '_blank');
        } else {
          console.log(e);
          this.$message.error('无查看权限');
        }
      } catch (e) {
        // this.$message.error(e);
        console.log(e);
      }
    },
    gotoAllMeetingAudios() {
      this.callback('3');
      this.searchType = 1;
      this.clickFile(MEETING_AUDIO_FILETYPE_ID);
    },
    launchVote() {
      this.askVoteModal = false;
      this.getVoteList();
    },
    cancelVote() {
      this.askVoteModal = false;
    },
    choseBackUserIds(value) {
      this.backUserIds = value;
    },
    delBackUserIds(user) {
      this.backUserIds = this.backUserIds.filter(_user => _user.id !== user.id);
    },
    choseBackUserIds2(value) {
      this.backUserIds2 = value;
    },
    delBackUserIds2(user) {
      this.backUserIds2 = this.backUserIds2.filter(_user => _user.id !== user.id);
    },
    async getCompetitor() {
      this.competitorLoading = true;
      const res = await competitor({
        page: this.competitorNo,
        pageSize: this.competitorPage,
        companyId: Number(this.$route.query.id)
      });
      this.competitorLoading = false;
      if (res.code == 200) {
        let competitorList = res.data.list || [];
        competitorList.forEach((item, index) => {
          item.key = index;
        });
        this.competitorList = competitorList;
        this.competitorTotal = res.data.total;
      } else {
        this.competitorList = [];
        this.competitorTotal = 0;
      }
    },
    async getFinancing() {
      this.financeLoading = true;
      const res = await financing({
        page: this.financeNo,
        pageSize: this.financePage,
        companyId: Number(this.$route.query.id)
      });
      this.financeLoading = false;
      if (res.code === 200) {
        let financeList = res.data.list || [];
        financeList.forEach((item, index) => {
          item.key = index;
        });
        this.financeList = financeList;
        this.financeTotal = res.data.total;
      } else {
        this.financeList = [];
        this.financeTotal = 0;
      }
    },
    taskTagChange(tag) {
      this.notesTagIds = tag;
      this.visibleTaskTagMenu = false;
    },
    getuserList() {
      searchByName('').then(res => {
        if (res.code === 200) {
          this.projectMemberList = res.data.list;
        } else {
          this.projectMemberList = [];
        }
      });
    },
    notifyChange(value) {
      this.notifyUserIds = value;
    },
    // notes的tag筛选
    tagsChange(obj) {
      if (obj.flag) {
        this.tags.push(obj.code);
      } else {
        this.tags.splice(this.tags.indexOf(obj.code), 1);
      }
      this.page = 1;
      this.companyNotes = [];
      this.$ga.gaUploadCustomEvent('项目-工作进展-筛选标签', this.tags.join(','));
      this.getCompanyNotes();
    },
    tagList() {
      tagList('notes').then(res => {
        this.tagsList = res.data;
      });
    },
    loadMore() {
      ++this.page;
      this.getCompanyNotes();
    },
    PromiseForEach(data, cb) {
      let result = Promise.resolve();
      data.forEach((item, index) => {
        item.isEdit = false;
        item.isComent = false;
        item.isShow = false;
        item.isunfold = true;
        result = result.then(() => {
          return cb(item, index).then(res => {
            if (!res) return;
            item.comments = res.data;
          });
        });
      });
      return result.then(() => {
        return data;
      });
    },
    async getCompanyNotes() {
      this.notesLoading = true;
      const res = await getCompanyNotes({
        companyId: this.$route.query.id,
        tagIds: this.tags.join(','),
        searchUserId: this.searchUserId,
        page: this.page,
        pageSize: this.pageNum,
        phase: this.phase,
        roundId: this.round
      });
      if (res.code === 200) {
        if (res.data.list) {
          this.load_more = true;
          let list = res.data.list;
          this.PromiseForEach(list, (ele, i) => {
            return new Promise((resolve, reject) => {
              if (ele.comments.total != 0) {
                const resp = getComment(ele.id);
                resolve(resp);
              }
              resolve();
            });
          }).then(data => {
            this.companyNotes = this.companyNotes.concat(data);
            this.notesLoading = false;
            if (this.page * this.pageNum >= res.data.total) {
              this.load_more = false;
            }
          });
        } else {
          this.load_more = false;
          this.notesLoading = false;
        }
      } else {
        this.companyNotes = [];
      }
    },
    handleInfiniteOnLoad() {
      if (this.meetloading || this.meetPage * 10 > this.meetTotal) return;
      ++this.meetPage;
      this.meetloading = true;
      getMeeting({
        page: this.meetPage,
        pageSize: 10,
        searchName: '',
        companyId: this.$route.query.id
      }).then(res => {
        if (res.code === 200) {
          this.meetloading = false;
          let list = res.data.list || [];
          this.meetingList = this.meetingList.concat(list);
        }
      });
    },
    async setPermissionUsers() {
      let canViewUserIds = [];
      let canDownloadUserIds = [];
      let canOperateUserIds = [];
      if (this.authType == '0') {
        this.permission.forEach(item => {
          if (item.companyFileTypeId == 0) {
            item.users.forEach(user => {
              canViewUserIds.push(user.id);
            });
          } else if (item.companyFileTypeId == 1) {
            item.users.forEach(user => {
              canDownloadUserIds.push(user.id);
            });
          } else {
            item.users.forEach(user => {
              canOperateUserIds.push(user.id);
            });
          }
        });
      } else {
        this.customPermission.forEach(item => {
          if (item.companyFileTypeId == 0) {
            item.users.forEach(user => {
              canViewUserIds.push(user.id);
            });
          } else if (item.companyFileTypeId == 1) {
            item.users.forEach(user => {
              canDownloadUserIds.push(user.id);
            });
          } else {
            item.users.forEach(user => {
              canOperateUserIds.push(user.id);
            });
          }
        });
      }
      const res = await setPermissionUsers({
        companyFileId: this.companyFileId,
        isDefault: this.authType == '0' ? true : false,
        canViewUserIds: canViewUserIds.join(','),
        canDownloadUserIds: canDownloadUserIds.join(','),
        canOperateUserIds: canOperateUserIds.join(',')
      });
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.permissionModal = false;
        if (this.currentKey == '1') {
          this.recentUpload();
        } else if (this.currentKey == '3') {
          this.getCompanyFile();
        }
      }
    },
    async getPermissionUsers(body) {
      this.permissionLoad = true;

      const res = await getPermissionUsers(body);
      this.permissionLoad = false;
      if (res.code === 200) {
        if (!this.customPermission.length) {
          //给this.authType赋值指定当前显示默认还是自定义
          this.authType = res.data.authType;
          this.customPermission = [...res.data.list];
        }
        this.permission = res.data.list;
      }
    },
    choseUserIds(users, index) {
      this.$set(this.customPermission, index, {
        companyFileTypeDesc: this.customPermission[index].companyFileTypeDesc,
        companyFileTypeId: this.customPermission[index].companyFileTypeId,
        users: users
      });
    },
    clickDelUser(index) {
      const item = (this.customPermission[index].users = []);
      item.users = [];
    },
    delUserIds(user, index) {
      const item = this.customPermission[index];
      item.users = item.users.filter(_user => _user.id != user.id);
    },
    checkTempEdit(index) {
      return this.tempEdit == index;
    },
    clickEditUser(index) {
      this.tempEdit = index;
    },
    clickFile(value) {
      this.current = 1;
      this.fileTypeId = [value];
      if (this.currentKey == '1') {
        this.recentUpload();
      } else if (this.currentKey == '3') {
        this.getCompanyFile();
      }
    },
    updateList() {
      if (this.currentKey == '1') {
        this.recentUpload();
      } else if (this.currentKey == '3') {
        this.getCompanyFile();
      }
    },
    clickAnnex(value) {
      this.annexId.push(...value);
      this.annexModal = false;
      this.recentUpload();
    },
    annexClose() {
      // this.$refs.document.closeEdit()
    },
    search: _.debounce(function() {
      this.getCompanyFile();
    }, 500),
    clickPermission(row) {
      // this.authType = String(row.authType) // 0 默认  1 自定义
      this.customPermission = [];
      this.companyFileId = [row.id];
      this.permissionModal = true;
      let body = {
        companyFileId: this.companyFileId
      };
      this.getPermissionUsers(body);
    },
    authChange(value) {
      this.authType = value.toString();
      if (this.authType == 0) {
        let body = {
          companyFileId: this.companyFileId,
          type: this.authType
        };
        this.getPermissionUsers(body);
      }
    },
    async clickCheck(row, clickType) {
      // 是飞书云文档
      if (['folder', 'file', 'docs', 'doc', 'docx', 'sheets', 'base', 'settings', 'wiki', 'minutes'].includes(row.feishuFileType)) {
        try {
          let res = await checkFeishuLinkPermission({
            companyFileId: row.id
          });
          if (res.code === 200) {
            window.open(res.data);
          }
        } catch (e) {
          console.log(e);
        }

        return;
      }
      this.companyFileId = row.id;
      let type = row.fileSuffix;

      // pdf格式预览：docx,doc,odt,ott,sxw,rtf,wpd,html,txt, xlsx,xls,ods,ots,sxc,xls,xlsx,csv,tsv, pptx,ppt,odp,otp,sxi,pdf
      // image图像格式：jpg,jpeg,png,gif,bmp,ico,raw
      // video视频格式：avi,mov,rmvb,rm,flv,mp4,3gp
      // const fileSuffix = [{type: 'pdf', strs: 'docx,doc,odt,ott,sxw,rtf,wpd,html,txt, xlsx,xls,ods,ots,sxc,xls,xlsx,csv,tsv, pptx,ppt,odp,otp,sxi,pdf'},{type: 'image', strs: 'jpg,jpeg,png,gif,bmp,ico,raw'},{type: 'video', strs: 'avi,mov,rmvb,rm,flv,mp4,3gp'}]

      let temp = fileSuffix.filter(item => item.strs.indexOf(type) > -1);

      if (+row.fileTypeId === MEETING_AUDIO_FILETYPE_ID) {
        this.gotoAudio(row, row.meetingType);
        return;
      }

      if (temp.length == 0) {
        type = null;
      } else {
        if (temp[0].type == 'video') {
          type = temp[0].type + '/' + type;
        } else {
          type = temp[0].type;
        }
        if (temp[0].type == 'pdf') {
          localStorage.setItem('download', row.canDownload);
          window.open(window.location.origin + '/pdfview?id=' + row.id + '&projectId=' + this.$route.query.id);
        } else {
          window.open(window.location.origin + '/pdfview?id=' + row.id + '&projectId=' + this.$route.query.id);
        }
      }
    },
    clickDownload(row) {
      this.companyFileId = row.id;
      downloadFileApi({
        fileType: 'projectFile',
        fileId: row.id
      }).then(res => {
        if (res.code == 200) {
          const downloadPath = res.data + '?Authorization=' + this.token;
          downloadFile(downloadPath);
        }
      });
    },
    clickEdit(row) {
      this.companyFileId = row.id;
      this.editModal = true;
      this.new_filename = row.name;
    },
    handleEdit() {
      editFileName({
        companyFileId: this.companyFileId,
        name: this.new_filename
      }).then(res => {
        this.getCompanyFile();
        this.editModal = false;
      });
    },
    onDelete(row) {
      deleteFile(row.id).then(res => {
        this.getCompanyFile();
      });
    },
    projectUpdate() {
      this.visibleProjectTagMenu = false;
      this.getDetail();
    },
    async getDetail(type = '') {
      let res = await getDetail(this.$route.query.id);
      this.pageLoading = false;
      if (res.code === 403) {
        this.applyAuthShow = true;
      } else {
        this.applyAuthShow = false;
        const { data } = res;
        if (data.status === -1) this.$router.replace('/404');
        this.project = data;
        this.projectBase = this.project.base || {};
        this.projectStage = this.project.stage || {};
        this.projectTagIds = data.tags;
        if (this.projectStage.phase === 0) {
          this.roundNameShow = this.projectStage.roundName;
        } else {
          this.roundNameShow = this.projectStage.raisingRoundName;
        }
        if (type === 'init') {
          const { id: userID } = this.userInfo || {};
          let projectMember = this.project.member;
          let isMember =
            projectMember['dls'].some(e => {
              return e.id === userID;
            }) ||
            projectMember['dms'].some(e => {
              return e.id === userID;
            });

          let { roundNameShow, projectStage, projectBase, project, phaseMap } = this;

          let data = {
            id: this.$route.query.id,
            round: roundNameShow + '轮' + phaseMap[projectStage.phase],
            state: projectBase.stateName,
            sector: projectBase.sectorName,
            dl: project.member.dls.map(e => e.nickname).join(','),
            isMember: isMember
          };
          // id 轮次 阶段 赛道 DL 成员
          this.$ga.gaUploadCustomEvent('项目访问', data);
        }
        this.getList();
        this.getHistoryStage();
        this.initPermissions();
        this.meetingStatusArr = [];
        this.getMeetingStatus();
      }
    },
    async getFinanceQuarterNewest() {
      let res = await getFinanceQuarterNewest({ companyId: this.$route.query.id });
      this.financeQuarterNewest = res.data;
      console.log(this.financeQuarterNewest);
    },
    async getHistoryStage() {
      try {
        let res = await historyStage({ id: this.$route.query.id, type: 1 });
        if (res.code === 200) {
          const { permissions: queue } = this.userInfo || {};
          this.projectRoundEditPermission = hasPermission(queue, '/project/round/edit');
          if (this.historyStage.length > 0) {
            let historyStage = res.data;
            let selectIndex = this.historyStage.findIndex(e => {
              return e.selected === true;
            });
            historyStage.forEach((e, index) => {
              if (index !== selectIndex) {
                e['selected'] = false;
              } else {
                e['selected'] = true;
              }
            });
            this.historyStage = historyStage;
          } else {
            this.historyStage = res.data;
            this.historyStage.forEach(_ => {
              this.roundMap[_.round] = _.roundName;
            });
            this.historyStage.forEach(e => {
              e['selected'] = false;
            });
          }
          this.roundValue = { round: this.historyStage[this.historyStage.length - 1].round, phase: this.historyStage[this.historyStage.length - 1].phase };
          this.selected = this.roundValue;
          this.historyStage.forEach(e => {
            this.historyStageMap[e.round] = e.roundName;
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    clickStage(stage, key) {
      // stage-伦次信息 key-roundList的index
      let roundName = `${stage.roundName}轮${stage.phase === 1 ? '融资期' : '发展期'}`;
      this.$ga.gaUploadCustomEvent('项目详情-筛选轮次时间轴', roundName);
      this.phase = stage.phase;
      this.round = stage.round;
      this.stageObj = stage;
      this.isSelectedAll = false;
      this.selectRoundNow = key;
      this.historyStage.forEach((e, index) => {
        if (index === key) {
          e.selected = true;
        } else {
          e.selected = false;
        }
      });
      this.getList();
    },
    selectAll() {
      this.stageObj = { phase: '', round: '' };
      this.phase = '';
      this.round = '';
      this.selectRoundNow = -1;
      this.isSelectedAll = true;
      this.historyStage.forEach(e => {
        e.selected = false;
      });
      this.getList();
    },
    getList() {
      this.companyNotes = [];
      if (this.currentKey == '1') {
        if (this.project.showNotes === true) {
          this.getCompanyNotes();
        }
        if (this.project.showFiles === true || this.project.showAudio === true) {
          this.recentUpload();
        }
        if (this.project.showMeeting === true) {
          this.getMeeting();
          // this.getMeetingStatus();
        }
        if (this.project.showVotes === true) {
          this.getVoteList();
        }
        this.tagList();
        this.getuserList();
      } else if (this.currentKey == '3' && this.project.showFiles === true) {
        this.getCompanyFile();
      } else if (this.currentKey == '4' && this.project.showThirdInfo === true) {
        this.getCompetitor();
        this.getFinancing();
      }
    },
    getNotes() {
      this.getCompanyNotes().then(() => {
        if (this.$route.query.meetingPromptId) {
          getNoSummaryList({ projectId: this.$route.query.id }).then(result => {
            if (result.code === 200) {
              this.noSummaryList = [...result.data].reverse().filter(item => {
                return item.meetingId == this.$route.query.meetingPromptId;
              });
              if (this.noSummaryList.length) {
                this.currentMeeting = this.noSummaryList[0] || [];
                this.backUserIds = [this.currentUser];
                this.backUserIds2 = [];
                this.notesTagIds = [];
                this.execDate = null;
                this.annexId = [];
                this.createLabel();
              }
            }
          });
        }
      });
    },
    // switchType(e) {
    //   this.searchType = e.target.value;
    //   this.current = 1;
    //   if (this.searchType == 0) {
    //     this.fileTypeId = [''];
    //     this.getCompanyFile();
    //   } else {
    //     this.getCompanyFile();
    //   }
    // },
    async getCompanyFile() {
      this.loading = true;
      const res = await getCompanyFile({
        companyId: this.$route.query.id,
        name: this.fileName,
        fileTypeId: this.fileTypeId,
        page: this.current,
        pageSize: this.pageSize,
        phase: this.phase,
        roundId: this.round
      });
      this.loading = false;
      if (res.code === 200) {
        this.documentList = res.data.list || [];
        this.totalNum = res.data.total;
        let fileTypeCount = res.data.fileTypeCount;
        let fileType = res.data.fileTypes.filter(item => item.status != -1);
        let total = 0;
        fileType.forEach(item => {
          item.total = fileTypeCount[item.id] ? fileTypeCount[item.id] : 0;
          total += item.total;
        });
        fileType.unshift({ id: '', name: '全部', total: total });
        this.fileType = fileType;
        const userInfo = this.userInfo || {};
        this.documentList.forEach(_ => {
          if (_.creator && _.creator.id === userInfo.id) {
            _.canTransfer = true;
          } else {
            _.canTransfer = false;
          }
        });
        const { permissions: queue } = this.userInfo || {};
        this.fileRoundEditPermission = hasPermission(queue, '/document/round/edit');
      }
    },
    async recentUpload() {
      let res = await recentUpload({ companyId: this.$route.query.id, phase: this.phase, roundId: this.round });
      if (res.code === 200) {
        if (res.data) {
          this.fileList = res.data.filter(file => +file.fileTypeId !== MEETING_AUDIO_FILETYPE_ID);
        } else {
          this.fileList = [];
        }
      }
      const resAudio = await getCompanyFile({
        companyId: this.$route.query.id,
        fileTypeId: MEETING_AUDIO_FILETYPE_ID,
        page: 1,
        pageSize: 10,
        phase: this.phase,
        roundId: this.round
      });
      if (resAudio.code === 200 && resAudio.data) {
        this.meetingAudioList = resAudio.data.list || [];
      }
    },
    // 筛选我的/全部notes
    handleChange(value) {
      this.$ga.gaUploadCustomEvent('项目-工作进展-筛选【全部/我的】', value);
      this.searchUserId = value;
      this.page = 1;
      this.companyNotes = [];
      this.getCompanyNotes();
    },
    async clickEditor() {
      //获取未提交会议纪要列表, 额这个命名应该叫NoSubmittedList...
      const result = await getNoSummaryList({ projectId: this.$route.query.id });
      if (result.code === 200) {
        this.noSummaryList = [...result.data].reverse();
        this.currentMeeting = result.data[0] || [];
      }
      if (this.noSummaryList.length) {
        this.isShowNotice = true;
      } else {
        this.showEdit = true;
      }
      this.backUserIds = [this.currentUser];
      this.backUserIds2 = [];
      this.notesTagIds = [];
      this.execDate = null;
      this.annexId = [];
      // this.$refs.vueWangeditor.setHtml('')
    },
    async onFillPRPDCA(e) {
      if (e.target.checked) {
        this.type = 5;
      } else {
        this.type = 1;
      }
    },
    initContent(value) {
      this.attachments = [];
      this.$refs.tinymceEditor.initTinymce();
      // if (value) {
      //   this.$refs.vueWangeditor.test()
      // } else {
      //   this.$refs.vueWangeditor.test()
      // }
    },
    async doContent() {
      this.defalutText = '';
      let content = this.$refs.tinymceEditor.getContent();
      let notesTag = [];
      this.notesTagIds.forEach(item => {
        notesTag.push(item.id);
      });
      let ownerUserIds = [];
      this.backUserIds.forEach(item => {
        ownerUserIds.push(item.id);
      });
      let notifyUserIds = [];
      this.backUserIds2.forEach(item => {
        notifyUserIds.push(item.id);
      });
      this.savenoteLoading = true;
      let body = {
        companyId: this.$route.query.id,
        content,
        fileIds: this.annexId.join(','),
        execDate: this.execDate ? this.execDate.format('YYYY-MM-DD') : '',
        notesTagIds: notesTag.join(','),
        ownerUserIds: ownerUserIds.join(','),
        notifyUserIds: notifyUserIds.join(','),
        meetingId: this.currentMeeting.meetingId || '',
        roundId: this.selected.round,
        phase: this.selected.phase,
        workProgressType: this.type
      };
      if (!this.currentMeeting.meetingId) {
        delete body.meetingId;
      }
      const res = await addCompanyNotes(body);
      this.savenoteLoading = false;
      if (res.code === 200) {
        this.attachments = [];
        this.showEdit = false;
        // const result = await getCompanyNotes({
        //   companyId: this.$route.query.id,
        //   tagIds: this.tags.join(','),
        //   searchUserId: this.searchUserId,
        //   page: 1,
        //   pageSize: 1,
        //   phase: this.phase,
        //   roundId: this.round
        // });
        // if (result.code === 200) {
        //   let list = result.data.list;
        //   list[0]['isEdit'] = false;
        //   list[0]['isComent'] = false;
        //   list[0]['isShow'] = false;
        //   this.companyNotes.unshift(list[0]);
        // }
        this.companyNotes = [];
        this.getNotes();
      }
    },
    initialize(id) {
      this.companyNotes.forEach((item, index) => {
        if (item.id === id) {
          this.companyNotes.splice(index, 1);
        }
      });
    },
    async updateData(id) {
      const res = await getCompanyNotes({
        companyId: this.$route.query.id,
        tagIds: this.tags.join(','),
        searchUserId: this.searchUserId,
        page: 1,
        pageSize: this.companyNotes.length,
        phase: this.phase,
        roundId: this.round
      });
      if (res.code === 200) {
        if (res.data.list) {
          let list = res.data.list;
          this.PromiseForEach(list, (ele, i) => {
            return new Promise((resolve, reject) => {
              if (ele.comments.total != 0) {
                const resp = getComment(ele.id);
                resolve(resp);
              }
              resolve();
            });
          }).then(data => {
            data.forEach((item, index) => {
              if (item.id == id) {
                const targetIndex = this.companyNotes
                  .map(item => {
                    return item.id;
                  })
                  .indexOf(id);
                this.companyNotes.splice(targetIndex, 1, item);
              }
            });
          });
        }
      }
    },
    callback(key) {
      this.currentKey = key;
      this.getDetail();
      this.$router.push(`${this.$route.path}?id=${this.$route.query.id}&tab=${key}`);
    },
    initPermissions() {
      this.permissionMap = getPermissions(['vote', 'createMeeting']);
      let askVotePermission = this.permissionMap['vote'];
      const { id: userID } = this.userInfo || {};
      let projectMember = this.project.member;
      let isMember =
        projectMember['dls'].some(e => {
          return e.id === userID;
        }) ||
        projectMember['dms'].some(e => {
          return e.id === userID;
        });
      this.showAskVote = askVotePermission || isMember;
    },
    getSelected(val) {
      this.selected = val;
    },
    async clickTransfer(row) {
      try {
        this.roundChangeModal = true;
        let res = await companyFileRoundInfo({ fileId: row.id });
        if (res.code === 200) {
          this.fileRoundInfo = res.data;
          if (this.fileRoundInfo.currRound && this.fileRoundInfo.currRound.length > 0) {
            this.fileRoundInfo['isCurrSecret'] = this.fileRoundInfo.currRound.some(_ => _.round === this.fileRoundInfo.raisingRound);
            this.fileRoundInfo['rounds'] = '';
            this.fileRoundInfo.currRound.forEach((_, index) => {
              if (index !== 0) {
                this.fileRoundInfo['rounds'] += '、' + _.roundName + '轮' + this.phaseMap[_.phase];
              } else {
                this.fileRoundInfo['rounds'] = _.roundName + '轮' + this.phaseMap[_.phase];
              }
            });
          }
          if (row.fileTypeId === SETTLEMENT_INVESRMENT_FILETYPE_ID || row.fileTypeId === SETTLEMENT_EXIT_FILETYPE_ID) {
            this.fileRoundInfo['isMulSelect'] = true;
          } else {
            this.fileRoundInfo['isMulSelect'] = false;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    getEditRound(val) {
      this.fileRoundAndPhase = val;
      if (val && Array.isArray(val) && val.length > 0) {
        this.$set(this.fileRoundInfo, 'editRound', '');
        let isEditSecret = val.some(_ => _.round === this.fileRoundInfo.raisingRound);
        this.$set(this.fileRoundInfo, 'isEditSecret', isEditSecret);
        val.forEach((_, index) => {
          if (index !== 0) {
            this.fileRoundInfo['editRound'] += '、';
          }
          this.fileRoundInfo['editRound'] += this.roundMap[_.round] + '轮' + this.phaseMap[_.phase];
        });
      } else if (!Array.isArray(val)) {
        this.$set(this.fileRoundInfo, 'isEditSecret', val.round === this.fileRoundInfo.raisingRound ? true : false);
        this.$set(this.fileRoundInfo, 'editRound', this.roundMap[val.round] + '轮' + this.phaseMap[val.phase]);
      } else {
        this.$delete(this.fileRoundInfo, 'isEditSecret');
        this.$delete(this.fileRoundInfo, 'editRound');
      }
    },
    async roundChange() {
      if (this.checkEditRound()) {
        try {
          let res = await roundChange({
            fileId: this.fileRoundInfo.fileId,
            fileRoundAndPhase: Array.isArray(this.fileRoundAndPhase) ? this.fileRoundAndPhase : [this.fileRoundAndPhase]
          });
          this.roundChangeClose();
          if (res.code === 200) {
            this.$message.success('保存成功');
            this.getCompanyFile();
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    checkEditRound() {
      if (!this.fileRoundAndPhase || this.fileRoundAndPhase.length <= 0) {
        this.$message.error('文档轮次不能为空');
        return false;
      }
      return true;
    },
    roundChangeClose() {
      this.roundChangeModal = false;
      this.reFresh = !this.reFresh;
    },
    async getMeetingStatus() {
      let res1 = await queryMeetingStatus({
        companyId: this.$route.query.id,
        meetingType: 1
      });
      if (res1.code === 200) {
        this.meetingStatusArr.push({
          meetingType: 1,
          status: res1.data.meetingStatus
        });
        this.editMeetingId = res1.data.meetingProjectId;
      }
      let res2 = await queryMeetingStatus({
        companyId: this.$route.query.id,
        meetingType: 2
      });
      if (res2.code === 200) {
        this.meetingStatusArr.push({
          meetingType: 2,
          status: res2.data.meetingStatus
        });
      }
    }
  }
};
